(function () {
  if (!window.CfonElements) return;

  function detailProductId(detail) {
    return detail && detail.productId != null ? String(detail.productId) : '';
  }

  function formatMoneyAmount(cents) {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '0.00';
    return (value / 100).toFixed(2);
  }

  function defaultSelectedOptions() {
    return [{ name: 'Title', value: 'Default Title' }];
  }

  function namedSelectedOptions(root) {
    const options = [];
    if (!root) return options;
    root.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
      options.push({
        name: input.dataset.optionName || '',
        value: input.dataset.optionValue || input.value || '',
      });
    });
    return options;
  }

  function matchingHost(selector, productId) {
    const hosts = Array.from(document.querySelectorAll(selector));
    if (!productId) return hosts[0] || null;
    return (
      hosts.find((el) => {
        const id = el.dataset.productId || '';
        return !id || id === String(productId);
      }) || null
    );
  }

  function matchingVariantPicker(productId) {
    return matchingHost('cfon-variant-picker', productId);
  }

  function matchingSellingPlans(productId) {
    return matchingHost('cfon-selling-plans', productId);
  }

  function dispatchProductSelect(element, { variant, selectedOptions, detail } = {}) {
    const { ProductSelectEvent } = window.StandardEvents || {};
    if (!ProductSelectEvent || !element) return;

    const options = selectedOptions && selectedOptions.length ? selectedOptions : defaultSelectedOptions();
    const deferred = ProductSelectEvent.createPromise();
    const payload = {
      product: {
        id: element.dataset.productId,
        title: element.dataset.productTitle,
        handle: element.dataset.productHandle,
      },
      selectedOptions: options,
      promise: deferred.promise,
    };
    if (detail) payload.detail = detail;

    element.dispatchEvent(new ProductSelectEvent(payload));

    if (variant) {
      deferred.resolve({
        variant: {
          id: variant.id,
          title: variant.title,
          availableForSale: Boolean(variant.available),
          price: {
            amount: formatMoneyAmount(variant.price),
            currencyCode: element.dataset.currencyCode,
          },
          selectedOptions: options,
        },
      });
      return;
    }

    deferred.resolve({ variant: null });
  }

  function dispatchCartLinesAdd(element, lines) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent || !element || !lines || !lines.length) return null;

    const deferred = CartLinesUpdateEvent.createPromise();
    element.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines,
        promise: deferred.promise,
      })
    );
    return { deferred, CartLinesUpdateEvent };
  }

  function dispatchCartErrorEvent(element, message, code) {
    const { CartErrorEvent } = window.StandardEvents || {};
    if (!CartErrorEvent || !element) return;
    element.dispatchEvent(new CartErrorEvent({ error: message || '', code: code || 'INVALID' }));
  }

  function resolveCartLinesFromAjax(handle, maybeCart) {
    if (!handle) return Promise.resolve();

    const finish = (cart) => {
      if (!cart || !cart.currency) {
        handle.deferred.reject(new Error('Missing currency in cart response'));
        return;
      }
      handle.deferred.resolve({ cart: handle.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
    };

    if (maybeCart && maybeCart.currency) {
      finish(maybeCart);
      return Promise.resolve();
    }

    const pending =
      typeof CartItems !== 'undefined' && typeof CartItems.fetchCartData === 'function'
        ? CartItems.fetchCartData()
        : fetch(`${(window.routes && routes.cart_url) || '/cart'}.js`).then((response) => response.json());

    return Promise.resolve(pending)
      .then(finish)
      .catch((error) => handle.deferred.reject(error));
  }

  // Analytics (CFON DataLayer brief, 2026-10-26). Selection events go to
  // window.dataLayer. Add-to-cart fields ride on Elevar's own dl_add_to_cart
  // through window.ElevarTransformFn so no second add_to_cart is sent.
  const SELECTION_EVENTS = ['select_variant', 'select_purchase_option', 'select_subscription_frequency'];
  const pendingAddContext = {};

  function pageType() {
    const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return (meta && meta.page && meta.page.pageType) || '';
  }

  function listContext(element) {
    const grid = element ? element.closest('cfon-product-grid') : null;
    return {
      item_list_id: grid ? grid.dataset.itemListId || '' : '',
      item_list_name: grid ? grid.dataset.itemListName || '' : '',
    };
  }

  function addToCartMethod(element) {
    const grid = element ? element.closest('cfon-product-grid') : null;
    if (grid) return grid.dataset.itemListType === 'collection' ? 'collection_quick_add' : 'other';
    return pageType() === 'product' ? 'pdp' : 'other';
  }

  // Cadence from a plan option value such as "30 days" or "2 weeks". Null when
  // the value does not state one, rather than guessing.
  function frequencyDays(value) {
    const match = /^\s*(\d+)\s*(day|week)s?\s*$/i.exec(value || '');
    if (!match) return null;
    const count = Number(match[1]);
    return match[2].toLowerCase() === 'week' ? count * 7 : count;
  }

  function emitSelection(eventName, element, data) {
    if (SELECTION_EVENTS.indexOf(eventName) === -1 || !data) return;
    const list = listContext(element);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      product_id: String(data.product_id || ''),
      variant_id: String(data.variant_id || ''),
      variant_name: data.variant_name || '',
      purchase_option: data.purchase_option || 'unknown',
      selling_plan_id: data.selling_plan_id ? String(data.selling_plan_id) : '',
      selling_plan_name: data.selling_plan_name || '',
      subscription_frequency_days: data.subscription_frequency_days || null,
      page_type: pageType(),
      item_list_id: list.item_list_id,
      item_list_name: list.item_list_name,
    });
  }

  function sellingPlanById(planId) {
    let found = null;
    document.querySelectorAll('[data-plans-by-variant]').forEach((node) => {
      if (found) return;
      try {
        const byVariant = JSON.parse(node.textContent);
        Object.keys(byVariant).some((key) => {
          found = byVariant[key].find((plan) => String(plan.id) === planId) || null;
          return found;
        });
      } catch (error) {
        found = null;
      }
    });
    return found;
  }

  // Elevar builds dl_add_to_cart from its own /cart.js reconcile. Each product
  // url is the cart line url, which carries ?selling_plan= only when the line
  // has a selling plan, so the cart line decides, not the UI toggle.
  function cartLineFields(product) {
    const unknown = { purchase_option: 'unknown', selling_plan_id: '', selling_plan_name: '', subscription_frequency_days: null };
    if (!product.url) return unknown;
    let planId = '';
    try {
      planId = new URL(product.url, window.location.origin).searchParams.get('selling_plan') || '';
    } catch (error) {
      return unknown;
    }
    if (!planId) {
      return { purchase_option: 'one_time', selling_plan_id: '', selling_plan_name: '', subscription_frequency_days: null };
    }
    const plan = sellingPlanById(planId);
    return {
      purchase_option: 'subscription',
      selling_plan_id: planId,
      selling_plan_name: plan ? plan.name || '' : '',
      subscription_frequency_days: plan ? frequencyDays(plan.interval) : null,
    };
  }

  // Checkout intent before the redirect. Not a begin_checkout.
  function emitCheckoutCta(entryPoint, cartPurchaseType) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'checkout_cta_click',
      checkout_entry_point: entryPoint,
      cart_purchase_type: cartPurchaseType || 'unknown',
      page_type: pageType(),
    });
  }

  // Cart type rendered by snippets/cart-purchase-type on the checkout buttons.
  // Null when no such button is on the page.
  function renderedCartPurchaseType() {
    const source = document.querySelector('[data-cart-purchase-type]');
    return source ? source.dataset.cartPurchaseType.trim() : null;
  }

  function mergeCartPurchaseType(cartType, addedLines) {
    if (cartType === null) return 'unknown';
    let subscription = cartType === 'subscription_only' || cartType === 'mixed';
    let oneTime = cartType === 'one_time_only' || cartType === 'mixed';
    addedLines.forEach((line) => {
      if (line && line.selling_plan_allocation) {
        subscription = true;
      } else {
        oneTime = true;
      }
    });
    if (subscription && oneTime) return 'mixed';
    if (subscription) return 'subscription_only';
    return oneTime ? 'one_time_only' : 'unknown';
  }

  // Line edits through cfon-cart swap only the cart regions, not the drawer
  // footer, so refresh the rendered cart type from any full-cart update.
  function syncCartPurchaseType(event) {
    const cart = event && event.cartData;
    if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') return;
    const type = cart.item_count ? mergeCartPurchaseType('', cart.items) : '';
    document.querySelectorAll('[data-cart-purchase-type]').forEach((element) => {
      element.dataset.cartPurchaseType = type;
    });
  }

  function rememberAddContext(element, variantId) {
    if (!variantId) return;
    pendingAddContext[String(variantId)] = Object.assign(
      { add_to_cart_method: addToCartMethod(element) },
      listContext(element)
    );
  }

  function enrichAddToCart(event) {
    if (!event || event.event !== 'dl_add_to_cart') return event;
    const add = event.ecommerce && event.ecommerce.add;
    const products = add && Array.isArray(add.products) ? add.products : [];
    let context = null;
    products.forEach((product) => {
      const key = String(product.variant_id || '');
      const entry = pendingAddContext[key];
      delete pendingAddContext[key];
      Object.assign(product, cartLineFields(product));
      if (entry) {
        product.item_list_id = entry.item_list_id;
        product.item_list_name = entry.item_list_name;
        context = context || entry;
      }
    });
    // Elevar drops unknown top-level keys; event_properties is kept.
    event.event_properties = Object.assign({}, event.event_properties, {
      add_to_cart_method: context ? context.add_to_cart_method : 'other',
    });
    return event;
  }

  class CfonProductForm extends CfonElements.Component {
    onConnect() {
      this.productId = this.dataset.productId || '';
      this.form = this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('form');
      this.variantInput = this.form ? this.form.querySelector('[name="id"]') : null;
      this.sellingPlanInput = this.form ? this.form.querySelector('input[name="selling_plan"]') : null;
      this.submitButton = this.form ? this.form.querySelector('[type="submit"][name="add"]') : null;
      this.submitLabel = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.buyNowButton = this.querySelector('[data-buy-now]');
      this.defaultToSubscription = this.boolAttr('defaultToSubscription', true);
      this.defaultSellingPlanId = this.dataset.defaultSellingPlanId || '';
      this.currentSellingPlanId = this.sellingPlanInput ? this.sellingPlanInput.value : '';
      this.hasSellingPlansUi = Boolean(this.querySelector('cfon-selling-plans'));

      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSellingPlanChange = this.onSellingPlanChange.bind(this);
      this.onBuyNowClick = this.onBuyNowClick.bind(this);
      this.onFormData = this.onFormData.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      document.addEventListener('cfon:variant-change', this.onVariantChange);
      document.addEventListener('cfon:selling-plan-change', this.onSellingPlanChange);

      if (this.form) {
        this.form.addEventListener('formdata', this.onFormData);
        this.form.addEventListener('submit', this.onSubmit);
      }

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', this.onBuyNowClick);
      }

      if (!this.hasSellingPlansUi) {
        this.applyFallbackSellingPlan();
      }
    }

    onDisconnect() {
      document.removeEventListener('cfon:variant-change', this.onVariantChange);
      document.removeEventListener('cfon:selling-plan-change', this.onSellingPlanChange);
      if (this.form) {
        this.form.removeEventListener('formdata', this.onFormData);
        this.form.removeEventListener('submit', this.onSubmit);
      }
      if (this.buyNowButton) {
        this.buyNowButton.removeEventListener('click', this.onBuyNowClick);
      }
    }

    onSubmit() {
      rememberAddContext(this, this.variantInput ? this.variantInput.value : '');
    }

    matchesProduct(detail) {
      const id = detailProductId(detail);
      if (!this.productId || !id) return true;
      return id === String(this.productId);
    }

    onVariantChange(event) {
      const detail = event.detail || {};
      if (!this.matchesProduct(detail)) return;
      this.applyVariant(detail.variant, detail.variantId);
    }

    onSellingPlanChange(event) {
      const detail = event.detail || {};
      if (!this.matchesProduct(detail)) return;
      this.applySellingPlan(detail.sellingPlanId);
    }

    applySellingPlan(sellingPlanId) {
      if (!this.form) return;
      const planId = sellingPlanId ? String(sellingPlanId) : '';
      this.currentSellingPlanId = planId;
      let inputs = this.form.querySelectorAll('input[name="selling_plan"]');
      if (!inputs.length) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.className = 'cfon-product-form__selling-plan';
        this.form.appendChild(input);
        inputs = [input];
      }
      inputs.forEach((input) => {
        if (!planId) {
          input.value = '';
          input.disabled = true;
          return;
        }
        input.disabled = false;
        input.value = planId;
      });
      this.sellingPlanInput = inputs[0];
    }

    onFormData(event) {
      const formData = event.formData;
      formData.delete('selling_plan');
      if (this.currentSellingPlanId) {
        formData.append('selling_plan', this.currentSellingPlanId);
      }
    }

    applyVariant(variant, variantId) {
      if (!this.variantInput) return;

      if (!variant && !variantId) {
        this.variantInput.value = '';
        this.variantInput.disabled = true;
        this.setSubmitState(false, 'unavailable');
        return;
      }

      const id = variant ? variant.id : variantId;
      const available = variant ? Boolean(variant.available) : true;
      this.variantInput.value = id;
      this.variantInput.disabled = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (!available) {
        this.setSubmitState(false, 'soldOut');
      } else {
        this.setSubmitState(true, 'addToCart');
      }
    }

    applyFallbackSellingPlan() {
      if (!this.sellingPlanInput) return;
      if (this.defaultToSubscription && this.defaultSellingPlanId) {
        this.applySellingPlan(this.defaultSellingPlanId);
      } else {
        this.applySellingPlan('');
      }
    }

    setSubmitState(enabled, labelKey) {
      if (this.submitButton) {
        this.submitButton.disabled = !enabled;
      }
      if (this.submitLabel && window.variantStrings && labelKey && window.variantStrings[labelKey]) {
        this.submitLabel.textContent = window.variantStrings[labelKey];
      }
      if (this.buyNowButton) {
        this.buyNowButton.disabled = !enabled;
      }
    }

    onBuyNowClick(event) {
      event.preventDefault();
      if (!this.variantInput || this.variantInput.disabled || !this.variantInput.value) return;

      const variantId = this.variantInput.value;
      const items = [
        {
          id: Number(variantId),
          quantity: 1,
        },
      ];
      if (this.currentSellingPlanId) {
        items[0].selling_plan = Number(this.currentSellingPlanId);
      }

      const config = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      const standardEvent = dispatchCartLinesAdd(this, [{ merchandiseId: variantId, quantity: 1 }]);
      rememberAddContext(this, variantId);

      fetch(`${config}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add failed');
          return response.json();
        })
        .then((added) => {
          // The rendered cart type is still the pre-add cart; merge in the added line.
          emitCheckoutCta('pdp_buy_now', mergeCartPurchaseType(renderedCartPurchaseType(), added.items || []));
          return resolveCartLinesFromAjax(standardEvent).then(() => {
            window.location.href = `${config}checkout`;
          });
        })
        .catch((error) => {
          dispatchCartErrorEvent(this, error && error.message ? error.message : 'Add failed', 'SERVICE_UNAVAILABLE');
          if (standardEvent) standardEvent.deferred.reject(error || new Error('Add failed'));
        });
    }
  }

  class CfonSellingPlans extends CfonElements.Component {
    onConnect() {
      this.productId = this.dataset.productId || '';
      this.requiresSellingPlan = this.boolAttr('requiresSellingPlan', false);
      this.showIntervals = this.boolAttr('showIntervals', false);
      this.plansByVariant = {};
      this.currentVariantId = this.dataset.initialVariantId || '';

      const plansNode = this.querySelector('[data-plans-by-variant]');
      if (plansNode) {
        try {
          this.plansByVariant = JSON.parse(plansNode.textContent);
        } catch (error) {
          this.plansByVariant = {};
        }
      }

      this.onHostClick = this.onHostClick.bind(this);
      this.onHostChange = this.onHostChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      this.addEventListener('click', this.onHostClick);
      this.addEventListener('change', this.onHostChange);
      document.addEventListener('cfon:variant-change', this.onVariantChange);

      this.rebuildSelect();
      this.publish();
    }

    onDisconnect() {
      this.removeEventListener('click', this.onHostClick);
      this.removeEventListener('change', this.onHostChange);
      document.removeEventListener('cfon:variant-change', this.onVariantChange);
    }

    getToggleButtons() {
      return Array.from(this.querySelectorAll('[data-purchase]'));
    }

    getIntervals() {
      return this.querySelector('[data-intervals]');
    }

    getSelect() {
      return this.querySelector('[data-selling-plan-select]');
    }

    onHostClick(event) {
      const button = event.target.closest('[data-purchase]');
      if (!button || !this.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      const purchase = button.dataset.purchase;
      if (!purchase) return;
      if (this.requiresSellingPlan && purchase === 'one_time') return;
      const wasSubscribe = this.isSubscribeSelected();

      this.getToggleButtons().forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const intervals = this.getIntervals();
      if (intervals) {
        const show = purchase === 'subscribe';
        intervals.hidden = !show;
        intervals.classList.toggle('is-hidden', !show);
      }

      this.publish({ standard: true });
      if (wasSubscribe !== (purchase === 'subscribe')) {
        this.track('select_purchase_option');
      }
    }

    onHostChange(event) {
      const select = event.target.closest('[data-selling-plan-select]');
      if (!select || !this.contains(select)) return;
      const previousPlanId = this.trackedPlanId;
      this.publish({ standard: true });
      if (this.isSubscribeSelected() && this.trackedPlanId && this.trackedPlanId !== previousPlanId) {
        this.track('select_subscription_frequency');
      }
    }

    purchaseFields() {
      const planId = this.resolvePlanId();
      const plan = this.plansForVariant(this.currentVariantId).find((entry) => String(entry.id) === planId);
      let purchaseOption = 'one_time';
      if (this.isSubscribeSelected()) purchaseOption = planId ? 'subscription' : 'unknown';
      return {
        purchase_option: purchaseOption,
        selling_plan_id: planId,
        selling_plan_name: plan ? plan.name || '' : '',
        subscription_frequency_days: plan ? frequencyDays(plan.interval) : null,
      };
    }

    track(eventName) {
      const picker = matchingVariantPicker(this.productId);
      const variant = picker && typeof picker.findVariant === 'function' ? picker.findVariant() : null;
      emitSelection(
        eventName,
        this,
        Object.assign(
          {
            product_id: this.productId,
            variant_id: this.currentVariantId,
            variant_name: variant ? variant.title : '',
          },
          this.purchaseFields()
        )
      );
    }

    onVariantChange(event) {
      const detail = event.detail || {};
      const id = detailProductId(detail);
      if (this.productId && id && id !== String(this.productId)) return;
      if (detail.variantId != null) {
        this.currentVariantId = String(detail.variantId);
      }
      this.rebuildSelect();
      this.publish();
    }

    isSubscribeSelected() {
      const selected = this.getToggleButtons().find((button) => button.classList.contains('is-selected'));
      return selected ? selected.dataset.purchase === 'subscribe' : this.boolAttr('defaultSubscription', true);
    }

    plansForVariant(variantId) {
      const key = variantId ? String(variantId) : Object.keys(this.plansByVariant)[0];
      const plans = key && this.plansByVariant[key] ? this.plansByVariant[key] : [];
      return Array.isArray(plans) ? plans : [];
    }

    rebuildSelect() {
      const select = this.getSelect();
      if (!select || !this.showIntervals) return;
      const plans = this.plansForVariant(this.currentVariantId);
      const previous = select.value;
      select.innerHTML = '';
      plans.forEach((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = plan.label;
        select.appendChild(option);
      });
      if (plans.length === 0) {
        select.value = '';
        return;
      }
      const match = plans.find((plan) => String(plan.id) === previous);
      select.value = match ? String(match.id) : String(plans[0].id);
    }

    resolvePlanId() {
      if (!this.isSubscribeSelected()) return '';
      const plans = this.plansForVariant(this.currentVariantId);
      const select = this.getSelect();
      if (this.showIntervals && select && select.value) {
        return select.value;
      }
      if (plans.length > 0) return String(plans[0].id);
      return '';
    }

    syncFormInput(sellingPlanId) {
      const host = this.closest('cfon-product-form');
      const form =
        this.closest('form[data-type="add-to-cart-form"]') ||
        this.closest('form') ||
        (host && host.querySelector('form[data-type="add-to-cart-form"]'));
      if (!form) return;
      const inputs = form.querySelectorAll('input[name="selling_plan"]');
      const planId = sellingPlanId ? String(sellingPlanId) : '';
      inputs.forEach((input) => {
        if (!planId) {
          input.value = '';
          input.disabled = true;
          return;
        }
        input.disabled = false;
        input.value = planId;
      });
    }

    publish(options) {
      const sellingPlanId = this.resolvePlanId();
      this.trackedPlanId = sellingPlanId;
      this.syncFormInput(sellingPlanId);
      this.dispatchEvent(
        new CustomEvent('cfon:selling-plan-change', {
          bubbles: true,
          composed: true,
          detail: {
            productId: this.productId,
            variantId: this.currentVariantId,
            sellingPlanId,
          },
        })
      );

      if (!options || !options.standard) return;

      const picker = matchingVariantPicker(this.productId);
      let variant = null;
      let selectedOptions = defaultSelectedOptions();
      if (picker && typeof picker.findVariant === 'function') {
        variant = picker.findVariant() || null;
        const fromPicker = namedSelectedOptions(picker);
        if (fromPicker.length) selectedOptions = fromPicker;
      }

      dispatchProductSelect(this, {
        variant,
        selectedOptions,
        detail: { sellingPlanId },
      });
    }
  }

  class CfonVariantPicker extends CfonElements.Component {
    onConnect() {
      this.productId = this.dataset.productId || '';
      this.optionInputs = Array.from(this.querySelectorAll('input[data-option-position]'));
      this.variantsNode = this.querySelector('[data-variants]');
      this.variants = [];

      if (this.variantsNode) {
        try {
          this.variants = JSON.parse(this.variantsNode.textContent);
        } catch (error) {
          this.variants = [];
        }
      }

      this.onOptionChange = this.onOptionChange.bind(this);
      this.optionInputs.forEach((input) => {
        input.addEventListener('change', this.onOptionChange);
      });

      this.updateSelectionUi();
      const variant = this.findVariant();
      this.trackedVariantId = variant ? String(variant.id) : '';
      this.publishVariant(variant);
    }

    onDisconnect() {
      this.optionInputs.forEach((input) => {
        input.removeEventListener('change', this.onOptionChange);
      });
    }

    onOptionChange() {
      this.updateSelectionUi();
      const variant = this.findVariant();
      this.publishVariant(variant, { standard: true });
      this.trackVariant(variant);
    }

    trackVariant(variant) {
      const variantId = variant ? String(variant.id) : '';
      if (variantId === this.trackedVariantId) return;
      this.trackedVariantId = variantId;
      const plans = matchingSellingPlans(this.productId);
      const purchase = plans && typeof plans.purchaseFields === 'function' ? plans.purchaseFields() : {};
      emitSelection(
        'select_variant',
        this,
        Object.assign({}, purchase, {
          product_id: this.productId,
          variant_id: variantId,
          variant_name: variant ? variant.title : '',
        })
      );
    }

    updateSelectionUi() {
      this.optionInputs.forEach((input) => {
        const label = input.closest('.cfon-variant-picker__value');
        if (!label) return;
        label.classList.toggle('is-selected', input.checked);
      });
    }

    selectedOptions() {
      const selected = {};
      this.optionInputs.forEach((input) => {
        if (!input.checked) return;
        selected[input.dataset.optionPosition] = input.dataset.optionValue;
      });
      return selected;
    }

    findVariant() {
      const selected = this.selectedOptions();
      return this.variants.find((variant) => {
        return Object.keys(selected).every((position) => {
          const index = Number(position) - 1;
          return variant.options[index] === selected[position];
        });
      });
    }

    publishVariant(variant, options) {
      this.dispatchEvent(
        new CustomEvent('cfon:variant-change', {
          bubbles: true,
          composed: true,
          detail: {
            productId: this.productId,
            variantId: variant ? variant.id : null,
            variant: variant || null,
          },
        })
      );

      if (!options || !options.standard) return;

      dispatchProductSelect(this, {
        variant: variant || null,
        selectedOptions: namedSelectedOptions(this),
      });
    }
  }

  class CfonProductPrice extends CfonElements.Component {
    onConnect() {
      this.productId = this.dataset.productId || '';
      this.currentEl = this.querySelector('[data-price-current]');
      this.compareEl = this.querySelector('[data-price-compare]');
      this.priceMap = {};
      this.currentVariantId = this.dataset.initialVariantId || '';
      this.currentSellingPlanId = this.dataset.initialSellingPlanId || '';

      const mapNode = this.querySelector('[data-price-map]');
      if (mapNode) {
        try {
          this.priceMap = JSON.parse(mapNode.textContent);
        } catch (error) {
          this.priceMap = {};
        }
      }

      const plansHost = matchingSellingPlans(this.productId);
      if (plansHost && typeof plansHost.resolvePlanId === 'function') {
        this.currentSellingPlanId = plansHost.resolvePlanId() || '';
      }

      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSellingPlanChange = this.onSellingPlanChange.bind(this);
      document.addEventListener('cfon:variant-change', this.onVariantChange);
      document.addEventListener('cfon:selling-plan-change', this.onSellingPlanChange);
      this.render();
    }

    onDisconnect() {
      document.removeEventListener('cfon:variant-change', this.onVariantChange);
      document.removeEventListener('cfon:selling-plan-change', this.onSellingPlanChange);
    }

    matchesProduct(detail) {
      const id = detailProductId(detail);
      if (!this.productId || !id) return true;
      return id === String(this.productId);
    }

    onVariantChange(event) {
      const detail = event.detail || {};
      if (!this.matchesProduct(detail)) return;
      if (detail.variantId != null) {
        this.currentVariantId = String(detail.variantId);
      }
      this.render();
    }

    onSellingPlanChange(event) {
      const detail = event.detail || {};
      if (!this.matchesProduct(detail)) return;
      this.currentSellingPlanId = detail.sellingPlanId ? String(detail.sellingPlanId) : '';
      if (detail.variantId != null) {
        this.currentVariantId = String(detail.variantId);
      }
      this.render();
    }

    render() {
      const variantData = this.priceMap[this.currentVariantId] || this.priceMap[Object.keys(this.priceMap)[0]];
      if (!variantData || !this.currentEl) return;

      let price = variantData.price;
      let compareAt = variantData.compare_at;

      if (this.currentSellingPlanId && variantData.plans && variantData.plans[this.currentSellingPlanId]) {
        const planPrice = variantData.plans[this.currentSellingPlanId];
        price = planPrice.price;
        compareAt = planPrice.compare_at;
      }

      this.currentEl.textContent = price || '';
      if (this.compareEl) {
        if (compareAt) {
          this.compareEl.textContent = compareAt;
          this.compareEl.hidden = false;
        } else {
          this.compareEl.textContent = '';
          this.compareEl.hidden = true;
        }
      }
    }
  }

  CfonElements.define('cfon-product-form', CfonProductForm);
  CfonElements.define('cfon-selling-plans', CfonSellingPlans);
  CfonElements.define('cfon-variant-picker', CfonVariantPicker);
  CfonElements.define('cfon-product-price', CfonProductPrice);

  class CfonStickyAtc extends CfonElements.Component {
    onConnect() {
      this.productId = this.dataset.productId || '';
      this.secondaryAction = this.dataset.secondaryAction || 'buy_now';
      this.secondaryUrl = this.dataset.secondaryUrl || '';
      this.atcButton = this.querySelector('[data-sticky-atc]');
      this.secondaryButton = this.querySelector('button[data-sticky-secondary]');
      this.productForm = this.findProductForm();
      this.observeTarget = this.findObserveTarget();

      this.onAtcClick = this.onAtcClick.bind(this);
      this.onSecondaryClick = this.onSecondaryClick.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
      this.syncBodyOffset = this.syncBodyOffset.bind(this);

      if (this.atcButton) {
        this.atcButton.addEventListener('click', this.onAtcClick);
      }
      if (this.secondaryButton) {
        this.secondaryButton.addEventListener('click', this.onSecondaryClick);
      }

      if (this.observeTarget && typeof IntersectionObserver !== 'undefined') {
        this.observer = new IntersectionObserver(this.onIntersect, {
          root: null,
          threshold: 0,
        });
        this.observer.observe(this.observeTarget);
      } else {
        this.classList.add('is-visible');
      }

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.syncBodyOffset);
        this.resizeObserver.observe(this);
      }

      this.syncDisabled();
      this.syncBodyOffset();
    }

    onDisconnect() {
      if (this.atcButton) {
        this.atcButton.removeEventListener('click', this.onAtcClick);
      }
      if (this.secondaryButton) {
        this.secondaryButton.removeEventListener('click', this.onSecondaryClick);
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      this.clearBodyOffset();
    }

    findProductForm() {
      if (!this.productId) {
        return document.querySelector('cfon-product-form');
      }
      return document.querySelector(`cfon-product-form[data-product-id="${this.productId}"]`);
    }

    findObserveTarget() {
      if (!this.productForm) return null;
      return (
        this.productForm.querySelector('.cfon-product-form__submit') ||
        this.productForm.querySelector('[type="submit"][name="add"]')
      );
    }

    syncBodyOffset() {
      const height = this.classList.contains('is-visible') ? this.offsetHeight : 0;
      document.documentElement.style.setProperty('--cfon-sticky-atc-offset', `${height}px`);
    }

    clearBodyOffset() {
      document.documentElement.style.removeProperty('--cfon-sticky-atc-offset');
    }

    onIntersect(entries) {
      const entry = entries[0];
      if (!entry) return;
      const show = !entry.isIntersecting;
      this.classList.toggle('is-visible', show);
      if (show) this.syncDisabled();
      this.syncBodyOffset();
    }

    syncDisabled() {
      const submit = this.findObserveTarget();
      const disabled = submit ? submit.disabled : false;
      if (this.atcButton) this.atcButton.disabled = disabled;
      if (this.secondaryButton) this.secondaryButton.disabled = disabled;
    }

    onAtcClick(event) {
      event.preventDefault();
      this.productForm = this.productForm || this.findProductForm();
      const submit = this.findObserveTarget();
      if (!submit || submit.disabled) return;
      submit.click();
    }

    onSecondaryClick(event) {
      event.preventDefault();
      this.productForm = this.productForm || this.findProductForm();
      if (!this.productForm) return;

      if (this.secondaryAction === 'url' && this.secondaryUrl) {
        window.location.href = this.secondaryUrl;
        return;
      }

      const buyNow = this.productForm.querySelector('[data-buy-now]');
      if (buyNow && !buyNow.disabled) {
        buyNow.click();
        return;
      }

      if (typeof this.productForm.onBuyNowClick === 'function') {
        this.productForm.onBuyNowClick(event);
      }
    }
  }

  CfonElements.define('cfon-sticky-atc', CfonStickyAtc);

  class CfonAddAll extends CfonElements.Component {
    onConnect() {
      this.button = this.querySelector('[data-add-all]');
      this.spinner = this.querySelector('.loading__spinner');
      this.items = this.readItems();
      this.onClick = this.onClick.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.onClick);
        if (!this.items.length) {
          this.button.disabled = true;
        }
      }
    }

    onDisconnect() {
      if (this.button) {
        this.button.removeEventListener('click', this.onClick);
      }
    }

    readItems() {
      const node = this.querySelector('[data-add-all-items]');
      if (!node) return [];
      try {
        const items = JSON.parse(node.textContent);
        return Array.isArray(items) ? items : [];
      } catch (error) {
        return [];
      }
    }

    setLoading(loading) {
      if (!this.button) return;
      this.button.classList.toggle('loading', loading);
      this.button.setAttribute('aria-disabled', loading ? 'true' : 'false');
      if (loading) {
        this.button.setAttribute('disabled', 'disabled');
      } else if (this.items.length) {
        this.button.removeAttribute('disabled');
      }
      if (this.spinner) {
        this.spinner.classList.toggle('hidden', !loading);
      }
    }

    onClick(event) {
      event.preventDefault();
      if (!this.button || this.button.disabled || !this.items.length) return;

      this.setLoading(true);

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: this.items };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      const config = fetchConfig('javascript');
      config.body = JSON.stringify(body);

      const standardEvent = dispatchCartLinesAdd(
        this,
        this.items.map((item) => ({
          merchandiseId: item.id,
          quantity: item.quantity || 1,
        }))
      );

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cfon-add-all',
              errors: response.errors || response.description,
              message: response.message,
            });
            dispatchCartErrorEvent(this, response.description || response.message, 'INVALID');
            if (standardEvent) standardEvent.deferred.reject(new Error(response.description || response.message));
            return;
          }

          if (!cart) {
            return resolveCartLinesFromAjax(standardEvent).then(() => {
              window.location = window.routes.cart_url;
            });
          }

          return resolveCartLinesFromAjax(standardEvent, response).then(() => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cfon-add-all',
              cartData: response,
            });

            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            cart.renderContents(response);
          });
        })
        .catch((error) => {
          dispatchCartErrorEvent(this, (error && error.message) || 'Network error', 'SERVICE_UNAVAILABLE');
          if (standardEvent) standardEvent.deferred.reject(error || new Error('Network error'));
        })
        .finally(() => {
          this.setLoading(false);
        });
    }
  }

  CfonElements.define('cfon-add-all', CfonAddAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartPurchaseType);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"][data-checkout-entry-point]');
    if (!button || button.disabled) return;
    emitCheckoutCta(button.dataset.checkoutEntryPoint, button.dataset.cartPurchaseType.trim());
  });

  const previousElevarTransform = window.ElevarTransformFn;
  window.ElevarTransformFn = function (event) {
    const next = typeof previousElevarTransform === 'function' ? previousElevarTransform(event) : event;
    return enrichAddToCart(next);
  };
})();
